import calendarInlinePaginatorComponent from './calendarInlinePaginator.component';

let calendarInlinePaginatorModule = angular.module('vacations-absences.calendarInlinePaginator', [])

.component('calendarInlinePaginator', calendarInlinePaginatorComponent)

.name;

export default calendarInlinePaginatorModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlinePaginator/calendarInlinePaginator.js